/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { PhoneDetails } from './PhoneDetails';
import {
  PhoneDetailsFromJSON,
  PhoneDetailsFromJSONTyped,
  PhoneDetailsToJSON,
} from './PhoneDetails';
import type { EmailDetails } from './EmailDetails';
import {
  EmailDetailsFromJSON,
  EmailDetailsFromJSONTyped,
  EmailDetailsToJSON,
} from './EmailDetails';
import type { Address } from './Address';
import {
  AddressFromJSON,
  AddressFromJSONTyped,
  AddressToJSON,
} from './Address';

/**
 *
 * @export
 * @interface LeadPatch
 */
export interface LeadPatch {
  /**
   * List of addresses
   * @type {Array<Address>}
   * @memberof LeadPatch
   */
  addresses?: Array<Address>;
  /**
   *
   * @type {object}
   * @memberof LeadPatch
   */
  custom?: object;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  department?: string | null;
  /**
   * List of email details
   * @type {Array<EmailDetails>}
   * @memberof LeadPatch
   */
  emails?: Array<EmailDetails>;
  /**
   *
   * @type {number | null}
   * @memberof LeadPatch
   */
  engagementScore?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  externalId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  firstName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  industry?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  jobTitle?: string | null;
  /**
   * 2-letter country code
   * @type {string | null}
   * @memberof LeadPatch
   */
  lang?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  lastName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  leadCompanyId?: string | null;
  /**
   *
   * @type {number | null}
   * @memberof LeadPatch
   */
  leadScore?: number | null;
  /**
   * List of phone details
   * @type {Array<PhoneDetails>}
   * @memberof LeadPatch
   */
  phones?: Array<PhoneDetails>;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  preferredMedium?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPatch
   */
  role?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadPatch
   */
  tags?: Array<any>;
  /**
   * e.g. 'US/Pacific', 'UTC', etc
   * @type {string | null}
   * @memberof LeadPatch
   */
  timezone?: string | null;
}

/**
 * Check if a given object implements the LeadPatch interface.
 */
export function instanceOfLeadPatch(value: object): value is LeadPatch {
  return true;
}

export function LeadPatchFromJSON(json: any): LeadPatch {
  return LeadPatchFromJSONTyped(json, false);
}

export function LeadPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LeadPatch {
  if (json == null) {
    return json;
  }
  return {
    addresses:
      json['addresses'] == null
        ? undefined
        : (json['addresses'] as Array<any>).map(AddressFromJSON),
    custom: json['custom'] == null ? undefined : json['custom'],
    department: json['department'] == null ? undefined : json['department'],
    emails:
      json['emails'] == null
        ? undefined
        : (json['emails'] as Array<any>).map(EmailDetailsFromJSON),
    engagementScore:
      json['engagement_score'] == null ? undefined : json['engagement_score'],
    externalId: json['external_id'] == null ? undefined : json['external_id'],
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    industry: json['industry'] == null ? undefined : json['industry'],
    jobTitle: json['job_title'] == null ? undefined : json['job_title'],
    lang: json['lang'] == null ? undefined : json['lang'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    leadCompanyId:
      json['lead_company_id'] == null ? undefined : json['lead_company_id'],
    leadScore: json['lead_score'] == null ? undefined : json['lead_score'],
    phones:
      json['phones'] == null
        ? undefined
        : (json['phones'] as Array<any>).map(PhoneDetailsFromJSON),
    preferredMedium:
      json['preferred_medium'] == null ? undefined : json['preferred_medium'],
    role: json['role'] == null ? undefined : json['role'],
    tags: json['tags'] == null ? undefined : json['tags'],
    timezone: json['timezone'] == null ? undefined : json['timezone'],
  };
}

export function LeadPatchToJSON(value?: LeadPatch | null): any {
  if (value == null) {
    return value;
  }
  return {
    addresses:
      value['addresses'] == null
        ? undefined
        : (value['addresses'] as Array<any>).map(AddressToJSON),
    custom: value['custom'],
    department: value['department'],
    emails:
      value['emails'] == null
        ? undefined
        : (value['emails'] as Array<any>).map(EmailDetailsToJSON),
    engagement_score: value['engagementScore'],
    external_id: value['externalId'],
    first_name: value['firstName'],
    industry: value['industry'],
    job_title: value['jobTitle'],
    lang: value['lang'],
    last_name: value['lastName'],
    lead_company_id: value['leadCompanyId'],
    lead_score: value['leadScore'],
    phones:
      value['phones'] == null
        ? undefined
        : (value['phones'] as Array<any>).map(PhoneDetailsToJSON),
    preferred_medium: value['preferredMedium'],
    role: value['role'],
    tags: value['tags'],
    timezone: value['timezone'],
  };
}
